<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-2">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("payrollCycleDate.pcDateName")
          }}</label>
          <input
            v-model="model.pc_date_name"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': errors.has('pc_date_name'),
            }"
            :placeholder="$t('payrollCycleDate.pcDateName')"
          />
          <div class="invalid-feedback" v-if="errors.has('pc_date_name')">
            {{ errors.first("pc_date_name") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 tw-space-y-1">
          <label class="required">{{ $t("payrollCycleDate.dayFrom") }}</label>
          <input
            v-model="model.day_from"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': errors.has('day_from'),
            }"
            :placeholder="$t('payrollCycleDate.dayFrom')"
          />
          <div class="invalid-feedback" v-if="errors.has('day_from')">
            {{ errors.first("day_from") }}
          </div>
        </div>
        <div class="col-6 tw-space-y-1">
          <label class="required">{{ $t("payrollCycleDate.dayTo") }}</label>
          <input
            v-model="model.day_to"
            type="text"
            class="form-control"
            :class="{
              'is-invalid': errors.has('day_to'),
            }"
            :placeholder="$t('payrollCycleDate.dayTo')"
          />
          <div class="invalid-feedback" v-if="errors.has('day_to')">
            {{ errors.first("day_to") }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 tw-space-x-2">
          <input v-model="model.monthly_based" type="checkbox" />
          <label>{{ $t("payrollCycleDate.monthlyBased") }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button v-if="!isUpdate" color="primary" @click.prevent="onSave">{{
            $t("save")
          }}</ts-button>
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { mapState } from "vuex";
import { Errors } from "form-backend-validation";

export default {
  name: "payrollCycleDateForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      model: {
        pc_date_id: null,
        pc_date_name: null,
        day_from: null,
        day_to: null,
        monthly_based: false,
      },
    };
  },
  computed: {
    ...mapState("humanResource/payrollCycleDate", ["edit_data"]),
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    this.setEditData();
  },
  methods: {
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("humanResource/payrollCycleDate/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("humanResource/payrollCycleDate/update", {
          id: this.edit_data.pc_date_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.pc_date_id = this.edit_data.pc_date_id;
        this.model.pc_date_name = this.edit_data.pc_date_name;
        this.model.day_from = this.edit_data.day_from;
        this.model.day_to = this.edit_data.day_to;
        this.model.monthly_based = this.edit_data.monthly_based;
      }
    },
  },
};
</script>
